import type { Tenant } from 'niara-spear-crudmodel'

export type MinimumTenant = Pick<
  Tenant,
  | 'id'
  | 'alias'
  | 'alias_replaced'
  | 'tenantId'
  | 'systemLocale'
  | 'userPoolClientId'
  | 'userPoolId'
  | 'supplierId'
  | 'modules_crs'
  | 'isBee2Pay'
  | 'DevOrHomologOrProd'
  | 'canary'
  | 'canaryStartDate'
  | 'canaryEndDate'
>

import callApi from './callApi'

const getTenant = async (tenantIdOrAlias: string): Promise<MinimumTenant> => {
  if (tenantIdOrAlias) {
    return callApi('niara-spear-commons', `/tenants/${tenantIdOrAlias}`, 'get').then((tenant) => {
      if (tenant == null) {
        throw new Error('i18n:Instalação não encontrada')
      }
      return tenant
    })
  }
  if (!tenantIdOrAlias) {
    throw new Error('i18n:Erro na url')
  }
}

const getCachedTenant = async (tenantIdOrAlias: string): Promise<MinimumTenant> => {
  if (window?.['_NIARA_B2C_CACHED_TENANT_']) return window['_NIARA_B2C_CACHED_TENANT_']
  return getTenant(tenantIdOrAlias).then((res) => {
    window['_NIARA_B2C_CACHED_TENANT_'] = res
    return res
  })
}
export default getCachedTenant
